<template>
  <!-- rider waitlist status start -->
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-8 col-xl-6">
        <div class="text-center mb-4">
          <a href="/portal">
            <img class="img-fluid" src="/assets/images/logo.svg" alt="Asher" style="max-width: 180px;"/>
          </a>
        </div>

        <div class="card shadow-sm">
          <div class="card-body text-center py-4">
            <div class="status-check mx-auto mb-3">
              <i class="fa fa-check"></i>
            </div>
            <h2 class="fw-bold mb-2">You're on the waitlist!</h2>
            <p class="text-muted mb-4">
              Thanks for joining Asher. You're all set — we'll let you know the moment
              Asher Rides launches in your area.
            </p>
            <a class="btn btn-outline-primary rounded-pill px-4" href="/logout">Log out</a>
          </div>
        </div>

        <RiderReferralDashboard />
      </div>
    </div>

    <RiderVerifyNudgeModal
        :email="email" :phone-number="phoneNumber"
        :email-verified="emailVerified" :phone-number-verified="phoneNumberVerified"
    />
  </div>
</template>

<script setup>
import RiderReferralDashboard from './RiderReferralDashboard.vue';
import RiderVerifyNudgeModal from './RiderVerifyNudgeModal.vue';

defineProps({
  waitlistStatus: { type: String, default: '' },
  email: { type: String, default: '' },
  phoneNumber: { type: String, default: '' },
  emailVerified: { type: Boolean, default: false },
  phoneNumberVerified: { type: Boolean, default: false },
});
</script>

<style scoped>
.status-check {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  background: rgba(var(--bs-success-rgb, 25, 135, 84), 0.12);
  color: var(--bs-success, #198754);
}
</style>
